import React, { Component, createRef } from 'react';
import { message, Pagination } from 'antd';
import CpEmpty from '../../components/CpEmpty';
import CpLoading from '../../components/CpLoading';
import { statusTextToIndex, IndexToStatusText, showNumber } from './utils/common';
import { inventoryOrders, inventoryOrderCancel, inventoryAgainOrder } from './api';
import RenderList from './components/renderList';
import { SearchForm } from './components/searchForm';
import moment from 'moment';
import './style.less';
import { downLoad } from '../../util/tool';
import { ROOT_PATH } from '../../origin';
import { queryString } from '../../util/qs';
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderList: [],
      currentStatus: -1,
      emptyStatus: 'proposalOrder',
      loading: true,
      paginationProps: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (current, pageSize) => this.pageChanged(current, pageSize)
      }
    };
    this.columns = [
      { key: 'time', name: '创建时间', align: 'left', padding: '0 0 0 12px' },
      { key: 'product', name: '商品详情', align: 'left', padding: '0' },
      { key: 'supply', name: '供应商', align: 'right', padding: '0' },
      { key: 'order_status', name: '交易状态', align: 'right', type: 1, padding: '0 12px 0 0' },
    ];
    this.searchRef = createRef();
  }

  componentDidMount() {
    const { paginationProps: { current: page, pageSize: page_size } } = this.state;
    this.requestOrderList({ page, page_size });
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  formateMoment = (values, value) => {
    const current = values[value] || [];
    let startTime, endTime;
    if (current.length) {
      const [start, end] = current;
      startTime = moment(start).format('YYYY-MM-DD');
      endTime = moment(end).format('YYYY-MM-DD');
    }
    return { [`${value}_start`]: startTime, [`${value}_end`]: endTime };
  }
  requestOrderList = async (params = {}) => {
    try {
      let { page: current = 1, page_size: pageSize = 10, order_status: currentStatus = -1 } = params;
      if (Number(params.order_status) === -1) {
        delete params.order_status;
      }
      const formValues = this.searchRef?.form?.getFieldsValue() || {};
      const create_time = this.formateMoment(formValues, 'create_time');
      const newFormValues = { ...formValues, create_time: undefined, order_status: formValues.order_status !== '-1' ? formValues.order_status : undefined };
      const { paginationProps } = this.state;
      const { data: { data = {}, msg, code } } = await inventoryOrders({ ...params, ...create_time, ...newFormValues });
      if (+code === 0) {
        const { list = [], total } = data;
        // isExpand: saleList.length > showNumber
        const orderList = list.map(item => ({ ...item, isExpand: item.product.length > showNumber }));
        this.setState({
          orderList,
          loading: false,
          currentStatus,
          activeStatus: IndexToStatusText[currentStatus],
          paginationProps: { ...paginationProps, current, pageSize, total }
        });
      } else {
        message.error(msg);
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  requestOrderExport = async () => {
    const formValues = this.searchRef?.form?.getFieldsValue() || {};
    const create_time = this.formateMoment(formValues, 'create_time');
    const newFormValues = { ...formValues, create_time: undefined, order_status: formValues.order_status !== '-1' ? formValues.order_status : undefined };
    downLoad({
      url: `${ROOT_PATH}/ipp/inventory/orders-export?${queryString({
        ...create_time,
        ...newFormValues,
        token: localStorage.getItem('token')
      })}`,
      name: `订货单数据-${moment(new Date()).format('YYYY-MM-DD')}.xlsx`
    });
  }

  toOrderDetail = (item) => {
    this.props.history.push('/basic/user/proposalList/detail/' + item.order_no);
  }

  cancelOrder = async (item) => {
    try {
      const { data: { msg, code } } = await inventoryOrderCancel({ order_no: item.order_no });
      if (+code === 0) {
        message.success(msg);
        let { current, pageSize } = this.state.paginationProps;
        this.requestOrderList({ page: current, page_size: pageSize });
      } else {
        message.error(msg);
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  againOrder = async (item) => {
    try {
      const { data: { msg, code, data } } = await inventoryAgainOrder({ order_no: item.order_no });
      if (+code === 0) {
        let cache = {};
        cache[item.supplier_id] = {
          selectedRowKeys: data.cart_ids,
          selectedRows: data.cart_list,
          checked: false,
          supplier_id: item.supplier_id,
          supplier_name: item.supplier_name
        };
        localStorage.setItem('select_rows_cache', JSON.stringify(cache));
        this.props.history.push('/basic/user/proposalCart');
      } else {
        message.error(msg);
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  stateChanged = (e) => {
    const { key } = e;
    let order_status = statusTextToIndex[key];
    this.setState({
      activeStatus: key,
      currentStatus: order_status
    });

    let { current, pageSize } = this.state.paginationProps;
    this.requestOrderList({ page: current, page_size: pageSize, order_status });
  }

  pageChanged = (page, pageSize) => {
    let { currentStatus } = this.state;
    this.requestOrderList({ page, page_size: pageSize, order_status: currentStatus });
  }

  toProductDetail = (product) => {
    const { spu_id, supplier_id, sale_id } = product;
    if (!spu_id || !supplier_id || !sale_id) {
      message.info('商品缺少spu_id或sale_id或supplier_id');
      return;
    }
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + sale_id);
  }
  expandFn = (item) => {
    const { isExpand, order_no } = item;
    const { orderList = [] } = this.state;
    const newOrderList = orderList.map(item => order_no === item.order_no ? { ...item, isExpand: !isExpand } : item);
    this.setState({ orderList: newOrderList });
  }
  render() {
    const { orderList, emptyStatus, loading, paginationProps } = this.state;
    const empty = (<div className="plan-order-empty"><CpEmpty status={emptyStatus} history={this.props.history} /></div>);
    return (
      <div className="proposal-order-list">
        <div className="title">我的订货单</div>
        <SearchForm ref={el => this.searchRef = el} searchFn={this.requestOrderList} exportFn={this.requestOrderExport}/>
        <div className="plan-order-content">
          {loading ? <CpLoading className="cp-loading" /> : null}
          {(orderList.length <= 0 && emptyStatus.length) ? empty : <RenderList {...{ formateList: orderList || [], toOrderDetail: this.toOrderDetail, expandFn: this.expandFn , cancelOrder: this.cancelOrder, againOrder: this.againOrder}} />}
        </div>
        {orderList.length <= 0 && (<div className="status-empty-tip"></div>)}
        <div className="pagination">{loading || (orderList.length <= 0 && emptyStatus.length) ? null : <Pagination {...paginationProps} />} </div>
      </div>
    );
  }
}
export default List;